/**
 * Utility functions for Atlas theme
 */

// Simple DOM ready function
export function ready(fn) {
	if (document.readyState !== 'loading') {
		fn();
	} else {
		document.addEventListener('DOMContentLoaded', fn);
	}
}

// Debounce function for resize handlers
export function debounce(func, wait, immediate) {
	let timeout;
	return function () {
		const context = this,
			args = arguments;
		const later = function () {
			timeout = null;
			if (!immediate) func.apply(context, args);
		};
		const callNow = immediate && !timeout;
		clearTimeout(timeout);
		timeout = setTimeout(later, wait);
		if (callNow) func.apply(context, args);
	};
}

// Element exists check
export function exists(selector) {
	return document.querySelector(selector) !== null;
}

// Viewport detection
export const viewport = {
	width: window.innerWidth,
	height: window.innerHeight,
	isPhone: () => window.innerWidth < 768,
	isTablet: () => window.innerWidth >= 768 && window.innerWidth < 1024,
	isDesktop: () => window.innerWidth >= 1024,
};

// Update viewport size on resize
window.addEventListener(
	'resize',
	debounce(() => {
		viewport.width = window.innerWidth;
		viewport.height = window.innerHeight;
	}, 250)
);

// Expose to global scope for backward compatibility
window.atlas = window.atlas || {};
window.atlas.utils = {
	debounce,
	exists,
	viewport,
};
